(function () {
  var root = document.getElementById('dxb');
  if (!root) return;
  var data;
  try { data = JSON.parse(document.getElementById('dxb-data').textContent); }
  catch (e) { return; }

  var state = { config: root.dataset.config, colour: root.dataset.colour };
  var vid = document.getElementById('dxb-vid');
  var qin = document.getElementById('dxb-qty');
  var form = document.getElementById('dxb-form');
  var els = {
    now: root.querySelector('.dxb-now'),
    was: root.querySelector('.dxb-was'),
    save: root.querySelector('.dxb-save'),
    main: root.querySelector('.dxb-main img'),
    add: root.querySelector('.dxb-add'),
    addlbl: root.querySelector('.dxb-add .lbl'),
    stickyP: root.querySelector('.dxb-sticky .p'),
    stickyBtn: root.querySelector('.dxb-sticky button')
  };

  function money(cents) {
    var s = (cents / 100).toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function find() {
    return data.find(function (v) { return v.config === state.config && v.colour === state.colour; });
  }
  function render() {
    root.querySelectorAll('.dxb-card').forEach(function (c) {
      c.classList.toggle('on', c.dataset.config === state.config);
    });
    root.querySelectorAll('.dxb-sw button').forEach(function (b) {
      b.classList.toggle('on', b.dataset.colour === state.colour);
    });
    var v = find();
    if (!v) return;
    vid.value = v.id;
    els.now.textContent = v.price;
    if (v.compareCents && v.compareCents > v.priceCents) {
      els.was.textContent = v.compare; els.was.style.display = '';
      els.save.textContent = 'Save ' + money(v.compareCents - v.priceCents); els.save.style.display = '';
    } else {
      els.was.style.display = 'none'; els.save.style.display = 'none';
    }
    if (v.img) { els.main.src = v.img; els.main.alt = v.config + ' in ' + v.colour; }
    var ok = v.available;
    els.add.disabled = !ok;
    if (els.addlbl) els.addlbl.textContent = ok ? ('Add to cart · ' + v.price) : 'Sold out';
    if (els.stickyP) els.stickyP.textContent = v.price;
    if (els.stickyBtn) { els.stickyBtn.textContent = ok ? 'Add to cart' : 'Sold out'; els.stickyBtn.disabled = !ok; }
    root.querySelectorAll('.dxb-thumbs button').forEach(function (t) {
      t.classList.toggle('on', t.dataset.src === v.img);
    });
  }

  root.querySelectorAll('.dxb-card').forEach(function (c) {
    c.addEventListener('click', function () { state.config = c.dataset.config; render(); });
  });
  root.querySelectorAll('.dxb-sw button').forEach(function (b) {
    b.addEventListener('click', function () { state.colour = b.dataset.colour; render(); });
  });
  root.querySelectorAll('.dxb-thumbs button').forEach(function (t) {
    t.addEventListener('click', function () {
      if (els.main) { els.main.src = t.dataset.src; }
      root.querySelectorAll('.dxb-thumbs button').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
    });
  });
  root.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var n = parseInt(qin.value, 10) || 1;
      n += (btn.dataset.qty === 'up' ? 1 : -1);
      if (n < 1) n = 1;
      qin.value = n;
    });
  });

  // ---- AJAX add to cart + Dawn cart drawer (Gymshark-style slide-out) ----
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function nativeSubmit() {
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }
  function busy(on) {
    if (els.add) { els.add.classList.toggle('loading', on); els.add.disabled = on; }
    if (els.stickyBtn) els.stickyBtn.disabled = on;
  }

  function addToCart() {
    var v = find();
    if (!v || !v.available) return;
    var qty = parseInt(qin && qin.value, 10) || 1;
    var drawer = document.querySelector('cart-drawer');

    // No drawer rendered on the page (cart_type != drawer): submit normally.
    if (!drawer || typeof drawer.renderContents !== 'function') { nativeSubmit(); return; }

    var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    busy(true);

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: v.id, quantity: qty }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          // Cart error (e.g. 422 sold out / not enough stock): surface, don't open.
          if (els.addlbl) els.addlbl.textContent = res.description || res.message || 'Unavailable';
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res); // refreshes sections + header count, then opens the drawer
      })
      .catch(function () {
        // Network failure: fall back to a normal add so the sale isn't lost.
        nativeSubmit();
      })
      .finally(function () { busy(false); render(); });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
  }
  if (els.stickyBtn) {
    els.stickyBtn.addEventListener('click', function () {
      if (!els.stickyBtn.disabled) addToCart();
    });
  }

  render();
})();
